import {createAction} from '@reduxjs/toolkit';

import type {ServerThread} from '../types/threads';

export const unmarkThreadManuallyUnread = createAction<{threadId: ServerThread['id']}>(
    'threads/actions/unmarkThreadManuallyUnread',
);
